// Note, constants are replaced right after tsc built the project.
// Update scripts/post-build.ts when requirements here change.
export const pkg = {
  name: '__PACKAGE_NAME__',
  version: '__PACKAGE_VERSION__',
  gitHash: '__GIT_HASH__',
};
